export default "__VITE_ASSET__BNQGA7Mz__"